import { createApp, watch } from 'vue'
import App from './App.vue'
import router from './router'
import { useTranslate } from './composables/useTranslate'
import './assets/styles/index.css'

createApp(App).use(router).mount('#app')

// Signal the build-time prerenderer (see vue.config.js) once the branded splash
// has cleared and the real page content is on screen — so snapshots capture the
// content, not the loading overlay. In the browser this event has no listeners,
// so it's a harmless no-op for real visitors.
const { loading } = useTranslate()
watch(
  loading,
  (v) => {
    // Wait past the splash's 0.5s leave-transition so the overlay is fully
    // removed from the DOM before the prerenderer takes its snapshot.
    if (!v) setTimeout(() => document.dispatchEvent(new Event('render-event')), 700)
  },
  { immediate: true },
)
